import * as R from 'ramda';


export default function BulkArchiveGeneratedReportInstancesDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  loaderService,
  ssDialogService,
  reportsDataService,
  bulkArchiveGeneratedReportInstancesConfirmDialog
) {
  const vm = this;
  
  vm.archiveIsSelected = false;
  vm.hasData = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleBulkArchive = _handleBulkArchive;
  vm.handleSelectAll = _handleSelectAll;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    $scope.$on('selectBulkReportInstanceChange', () => {
      _handleSelectReportInstanceChange();
    });
  }

  function _handleBulkArchive($event) {
    const _ids = [];

    R.forEach((reportInstance) => {
      if (reportInstance.isBulkArchive) {
        _ids.push(reportInstance.reportInstanceId);
      }
    }, vm.reportInstances);

    
    _checkForExistingConflicts(_ids);

    ssDialogService.dialogs.reports.bulkArchiveGeneratedReportInstancesConfirmDialog = ssDialogService.alert(
      bulkArchiveGeneratedReportInstancesConfirmDialog.getOptions($event, {
        reportTypeId: vm.reportType.uniqueId,
        reportInstanceIds: _ids,
        updateCallBack: _broadcastEvents,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.reports.bulkArchiveGeneratedReportInstancesConfirmDialog);
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.bulkArchiveGeneratedReportInstancesDialog);
  }

  function _handleSelectAll() {
    R.forEach((reportInstance) => {
      reportInstance.isBulkArchive = vm.selectAll;
      vm.archiveIsSelected = vm.selectAll;
    }, vm.reportInstances);
  }

  function _handleSelectReportInstanceChange() {
    const selectedIds = [];
    R.forEach((item) => {
      if (item.isBulkArchive === true) {
        selectedIds.push(item.reportInstanceId);
      }
    }, vm.reportInstances);
    vm.archiveIsSelected = selectedIds.length > 0;
    vm.selectAll = selectedIds.length === vm.reportInstances.length;
  }

  /** ************************************************
   * Private Functions
   */
  function _broadcastEvents() {
    $rootScope.$broadcast('refreshReportInstances', { reportType: vm.reportType });
  }

  function _checkForExistingConflicts(ids) {
    const idList = ids.join(',');
    reportsDataService.getArchiveConflicts(idList).then((response) => {
      try {
        if (response.data.hasIncompleteBCPAssessment === true || response.data.hasIncompleteRiskAssessment === true) {
          //  _enterpriseModelingDialogService.showassessmentInProgressDialog();
          let message1 = '';
          let message2 = '';
          if (response.data.hasIncompleteBCPAssessment === true) {
            message1 = `There is an open BCP assessment "${response.data.bcpAssessmentName}"`;
          }
          if (response.data.hasIncompleteRiskAssessment === true) {
            // eslint-disable-next-line max-len
            message2 += `There is an open Information Security - Risk Assessment "${response.data.riskAssessmentName}"`;
          }

          ssDialogService.dialogs.enterpriseModeling.assessmentInProgressDialog = ssDialogService.alert(
            assessmentInProgressDialog.getOptions($event, { message1, message2 })
          );
          ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.assessmentInProgressDialog);
        }
      } catch (error) {
        console.error(error);
      }
    });
  }
}

BulkArchiveGeneratedReportInstancesDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'loaderService',
  'ssDialogService',
  'reportsDataService',
  'bulkArchiveGeneratedReportInstancesConfirmDialog',
];
